import { createTheme } from '@material-ui/core';

const UNICEM_THEME = createTheme({
  palette: {
    primary: {
      main: '#1E5E9C'
    },
    secondary: {
      main: '#F0A457'
    },
    tertiary: {
      main: '#65B766'
    },
    error: {
      main: '#dc004e'
    },
    success: {
      main: '#65B766'
    }
  },
  typography: {
    htmlFontSize: 10,
    fontFamily: 'inherit',
    h1: {
      fontSize: '3.2rem'
    },
    h2: {
      fontSize: '2.8rem'
    },
    h3: {
      fontSize: '2.4rem'
    },
    h4: {
      fontSize: '2.2rem'
    },
    h5: {
      fontSize: '1.8rem'
    }
  },
  props: {
    MuiButton: {
      variant: 'contained'
    },
    MuiTextField: {
      color: 'secondary'
    },
    MuiCard: {
      elevation: 3
    }
  },
  overrides: {
    MuiButton: {
      text: {
        color: '#007db3'
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#007db3'
      }
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#007db3'
      }
    },
    MuiPickersYear: {
      yearSelected: {
        color: '#007db3'
      }
    },
    MuiTableCell: {
      root: {
        fontSize: '1.6rem'
      }
    },
    MuiStepIcon: {
      root: {
        color: '#F0A457'
      },
      active: {
        color: '#1E5E9C'
      },
      completed: {
        color: '#1E5E9C'
      }
    },
    MuiStepConnector: {
      alternativeLabel: {
        top: 9
      },
      active: {
        '& $line': {
          backgroundColor: '#1E5E9C'
        }
      },
      completed: {
        '& $line': {
          backgroundColor: '#1E5E9C'
        }
      },
      lineHorizontal: {
        borderTopWidth: 0,
        height: 6,
        border: 0,
        backgroundColor: '#F0A457'
      }
    },
    MuiRadio: {
      root: {
        color: 'inherit'
      },
      colorSecondary: {
        '&$checked': {
          color: '#1E5E9C'
        }
      }
    }
  },
  breakpoints: {
    values: {
      sm: 768
    }
  }
});

export default UNICEM_THEME;